import { render, staticRenderFns } from "./review_bar.vue?vue&type=template&id=25091134&"
import script from "./review_bar.vue?vue&type=script&lang=js&"
export * from "./review_bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "review_bar.vue"
export default component.exports